export const environment = {
  production: false,
  api_legacy: 'https://apil.dev.owlhub.com',
  api: 'https://api.dev.owlhub.com',
  access: 'https://access.dev.owlhub.com',
  assessments: 'https://app.dev.owlhub.com',
  ollie: 'https://ollie.dev.owlhub.com',
  admin: 'https://admin.dev.owlhub.com',
  domain: 'dev.owlhub.com',
  sessionIdleMinutes: 15,
  help_link: 'https://www.dropbox.com/scl/fo/srq8ottea0b2qrxoqw4no/ACLlvLNrz3Q38yjfHOS5Evs?rlkey=z53dsaduzpj2x322xa7he5prg&dl=0',
  new_relic: {
    enabled: true,
    accountId: '8427946',
    licenseKey: 'NRJS-b43faee984874006c55',
    beaconUrl: 'bam.nr-data.net',
    access: {
      applicationId: '653440376',
    },
    assessments: {
      applicationId: '653440377',
    },
    ollie: {
      applicationId: '653440378',
    }
  },
  okta: {
    issuer: 'https://integrator-3596696.okta.com/oauth2/default',
    clientId: '0oazoqfcfxx3FFFjr697',
    callbackUri: '/login/callback',
  }
};
